<template>
  <div class="flex size-full flex-col">
    <div
      v-if="step !== 'email'"
      class="relative mt-0 h-1 w-full bg-gray-100"
    >
      <div
        class="absolute left-0 top-0 h-1 bg-gray-700 transition-all duration-300"
        :style="{ width: `${progressPercent}%` }"
      ></div>
    </div>
    <div class="mt-7 flex size-full max-w-lg flex-col items-center self-center md:mt-10">
      <sign-up-email
        v-if="step === 'email'"
        @already-has-account="emit('update:modelValue', true)"
        @switch-to-sign-in="handleSwitchToSignIn"
      />
      <sign-up-user v-else-if="step === 'user'" />
      <sign-up-shop-kind v-else-if="step === 'shop-kind'" />
      <sign-up-shop-name v-else-if="step === 'shop-name'" />
      <sign-up-shop-category v-else-if="step === 'shop-category'" />
      <sign-up-shop-since v-else-if="step === 'shop-since'" />
      <sign-up-shop-sales v-else-if="step === 'shop-sales'" />
      <sign-up-shop v-else-if="step === 'shop'" />
      <sign-up-success
        v-else-if="step === 'success'"
        @close-dialog="emit('close-dialog')"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import useSignUpStore from 'stores/sign-up-store';
import signUpEmail from './sign-up-email.vue';
import signUpUser from './sign-up-user.vue';
import signUpShopKind from './sign-up-shop-kind.vue';
import signUpShopName from './sign-up-shop-name.vue';
import signUpShopCategory from './sign-up-shop-category.vue';
import signUpShopSince from './sign-up-shop-since.vue';
import signUpShopSales from './sign-up-shop-sales.vue';
import signUpShop from './sign-up-shop.vue';
import signUpSuccess from './sign-up-success.vue';

defineProps<{
  modelValue: boolean;
}>();

const signUpStore = useSignUpStore();
const emit = defineEmits<{ 
  (e: 'update:modelValue', value: boolean): void; 
  (e: 'close-dialog'): void;
  (e: 'switch-to-sign-in', email: string): void;
}>();
const step = computed(() => signUpStore.currentStep);

const handleSwitchToSignIn = (email: string) => {
  emit('switch-to-sign-in', email);
};

const progressPercent = computed(() => {
  if (step.value === 'email') return 0;
  if (step.value === 'user') return 12.5;
  if (step.value === 'shop-kind') return 25;
  if (step.value === 'shop-name') return 37.5;
  if (step.value === 'shop-category') return 50;
  if (step.value === 'shop-since') return 62.5;
  if (step.value === 'shop-sales') return 75;
  if (step.value === 'shop') return 87.5;
  if (step.value === 'success') return 100;
  return 0;
});
</script>
